import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFD600', // Amarelo Vibrante
      contrastText: '#000000', // Texto preto nos botões amarelos
    },
    background: {
      default: '#000000',
      paper: '#121212',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0b0b0',
    },
  },
  typography: {
    // --- ATUALIZAÇÃO DA FONTE ---
    fontFamily: "'Montserrat', sans-serif",
    h1: { fontWeight: 900 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 800 }, // Títulos de seção bem marcados
    h4: { fontWeight: 800 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    body1: {
      fontWeight: 400,
      lineHeight: 1.6, // Melhora o espaçamento entre as linhas no texto
    },
    button: {
      fontWeight: 700,
      letterSpacing: '0.5px', // Dá um leve respiro nas letras do botão
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          borderRadius: '4px', // Mantém o leve arredondamento
        },
      },
    },
  },
});